import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { cableId, type CableId } from './Cable.js'

/** Represents the view public.sensor_overview_view_ */
export default interface SensorOverviewViewTable {
  /** Database type: pg_catalog.text */
  sensorId: ColumnType<string, never, never>

  /** Database type: pg_catalog.int4 */
  cableId: ColumnType<CableId, never, never>

  /** Database type: pg_catalog.int4 */
  cableSerial: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.int8 */
  calibrationCount: ColumnType<string, never, never>

  /** Database type: pg_catalog.timestamptz */
  lastCalibrationDate: ColumnType<Date, never, never>
}

export type SensorOverviewView = Selectable<SensorOverviewViewTable>

export const sensorOverviewView = z.object({
  sensorId: z.string(),
  cableId: cableId,
  cableSerial: z.number().nullable().optional(),
  calibrationCount: z.string(),
  lastCalibrationDate: z.coerce.date(),
}) as unknown as z.Schema<SensorOverviewView>
